import { forwardRef, HTMLAttributes, useInsertionEffect } from 'react';
import { markdownHtml, MARKDOWN_STYLES } from '../general/markdown';

type Props = Omit<HTMLAttributes<HTMLElement>, 'children'> & { text?: string | null; inline?: boolean; legacyHtml?: boolean };

export const MarkdownText = forwardRef<HTMLDivElement, Props>(function MarkdownText({ text, inline = false, legacyHtml = false, className = '', ...props }, ref) {
    useInsertionEffect(() => {
        if (!document.getElementById('markdown-content-styles')) {
            const style = document.createElement('style');
            style.id = 'markdown-content-styles';
            style.textContent = MARKDOWN_STYLES;
            document.head.appendChild(style);
        }
    }, []);
    const html = { __html: markdownHtml(text, inline, legacyHtml) };
    return inline ? <span {...props} className={`markdown-inline ${className}`} dangerouslySetInnerHTML={html} />
        : <div {...props} ref={ref} className={`markdown-content ${className}`} dangerouslySetInnerHTML={html} />;
});
